import { createFileRoute } from "@tanstack/react-router";
import { Badge, EmptyState, PageHeader } from "@oms/ui";
import { PageShell } from "@/components/pages/page-shell";

export const Route = createFileRoute("/app/tracking")({
  component: TrackingPage,
});

function TrackingPage() {
  return (
    <PageShell>
      <PageHeader
        title="Tracking"
        description="Monitor shipments and delivery status in real time."
        actions={<Badge variant="neutral">Coming soon</Badge>}
      />
      <EmptyState
        title="Coming soon"
        description="Shipment tracking is under development. You'll be able to monitor delivery status here once this module launches."
      />
    </PageShell>
  );
}
